const addPageNumberParamToUrl = (pageNumber, url) => {
  const newUrl = new URL(url)
  if (newUrl.searchParams.has('page')) {
    newUrl.searchParams.set('page', pageNumber)
  } else {
    newUrl.searchParams.append('page', pageNumber)
  }
  return newUrl.toString()
}


const initLoadMore = (cb) => {
  const getTargetsFromWrapper = (targetWrapper) => targetWrapper ? [...targetWrapper.children] : []
  const container = document.querySelector('[data-products-container]');
  if (!container) {
    return false
  }
  const theObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(async ({ target, isIntersecting }) => {
      if (isIntersecting) {
        const targetList = target.parentNode;
        const pageNumber = parseInt(targetList.dataset.pageNumber);
        const url = addPageNumberParamToUrl(pageNumber, window.location.href)
        const direction = targetList.dataset.pageDirection;
        if (window.location.href.includes(url) || targetList.classList.contains('loading')) {
          return;
        }
        // console.log(pageNumber, console.log(url))
        window.history.replaceState({ ...history.state }, '', url)
        if (targetList.classList.contains('loaded')) {
          return;
        }
        targetList.classList.add('loading')
        const res = await fetch(url);
        const body = await res.text();
        const newProductSection = document.createElement('div');
        newProductSection.innerHTML = body;
        const newList = newProductSection.querySelector('[data-products-list]');
        const newListInner = newList.querySelector(`[data-page-number="${pageNumber}"]`)
        const nextList = newList.querySelector(`[data-page-number="${pageNumber + 1}"]`)
        if (direction === 'next') {
          targetList.classList.remove('loading')
          targetList.parentNode.removeChild(targetList);
          container.insertBefore(newList, null)
          newListInner.classList.add('loaded')
          const newTargets = [nextList, newListInner].flatMap(getTargetsFromWrapper)
          newTargets.forEach(newTarget => observer.observe(newTarget))
        } else if (direction === 'prev') {
          targetList.innerHTML = newListInner.innerHTML
          targetList.classList.remove('loading')
          targetList.classList.add('loaded')
          getTargetsFromWrapper(targetList).forEach(newTarget => observer.observe(newTarget))          
        } else {
          return;
        }
        if (cb) cb();
      }
    })
  }, {
    rootMargin: '0px',
    threshold: [0.5] // half any product card
  });

  const targetWrappers = container.querySelectorAll('[data-page-number]')
  const targetCards = [...targetWrappers].flatMap(getTargetsFromWrapper);
  targetCards.forEach(target => {
    theObserver.observe(target)
  })
  
};

// Blogs Landing Page Load More Functionality


export default initLoadMore;

